import { createAsyncThunk, rejectWithValue } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { fetchLeaveEntryApi, createLeaveEntryApi,getLeaveEntryByIdApi,updateLeaveEntryApi,checkDeleteLeaveEntryApi, deleteLeaveEntryApi } from "./LeaveApprovalApi";
import { showApiErrorToast, showApiSuccessToast} from "../../utils/toastErrorHandler";


const handleError = (err, rejectWithValue) => {
   console.log("Error object:", err);
  console.log("Response:", err.response?.data);
  if(err.response?.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  }
  const errorMessage = err.response?.data?.message ||
  err.response?.data.error || 
  err.message || "Something went wrong"

  showApiErrorToast(errorMessage)
  return rejectWithValue(err.response?.data || { message: err.message})
}


  export const fetchLeaveList = createAsyncThunk(
    "LeaveEntry/leave_list",
    async (payload, { rejectWithValue }) => {
      try {
        const response = await fetchLeaveEntryApi(payload);
        return response.data;
      } catch (error) {
        return rejectWithValue(
          error.response?.data || error.message
        );
      }
    }
  );

export const createLeaveEntry = createAsyncThunk(
  "LeaveEntry/create_leave",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createLeaveEntryApi(payload);
        showApiSuccessToast(
                      response.message
                  );
      return response; // or return response depending on your API function
    } catch (error) {
      return handleError(error, rejectWithValue);
      
    }
  }
);

export const getLeaveEntryById = createAsyncThunk(
  "LeaveEntry/get_by_id",
  async(id, { rejectWithValue }) => {
    try{
      const response = await getLeaveEntryByIdApi(id);
      return response;
    }
    catch(error) {
      return rejectWithValue(error.response?.data) || { message: error.message}
    }
  }
)
export const updateLeaveEntry = createAsyncThunk(
  "LeaveEntry/update_leave",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await updateLeaveEntryApi(id, payload);
      showApiSuccessToast(response.message);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const checkDeleteLeaveEntry = createAsyncThunk(
  "LeaveEntry/delete_message",
  async (id, { rejectWithValue }) => {
    try {
      const response = await checkDeleteLeaveEntryApi(id);
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

export const deleteLeaveEntry = createAsyncThunk(
  "LeaveEntry/delete_leave",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteLeaveEntryApi(id);

      showApiSuccessToast(response.message);

      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);
